module.exports = __webpack_public_path__ + "static/media/carrito.3a368e1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empresa/carrito.svg
// module id = 158
// module chunks = 0